import React from "react";
import { Row, Spinner } from "@masterteam/mt-design-react";
import Modal from "../Modal";
import FormHeader from "./FormHeader";
import styles from "./AdminFormModal.module.scss";

function AdminFormModal({
  isOpen = true,
  isLoading,
  onClose,
  title,
  Icon,
  children
}) {
  return (
    <Modal isOpen={isOpen}>
      <div className={styles.container}>
        <FormHeader title={title} Icon={Icon} onClose={onClose} />
        <div className={styles.content}>
          {isLoading ? (
            <Row justify="center">
              <Spinner />
            </Row>
          ) : (
            children
          )}
        </div>
      </div>
    </Modal>
  );
}

export default AdminFormModal;
